var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnarchiveSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 3.06066V10.25C7.75 10.6642 8.08577 11 8.5 11C8.91422 11 9.25 10.6642 9.25 10.25V3.06066L10.9697 4.78033C11.2626 5.07322 11.7374 5.07322 12.0303 4.78033C12.3232 4.48743 12.3232 4.01257 12.0303 3.71967L9.03032 0.719668C8.73745 0.426778 8.26255 0.426778 7.96968 0.719668L4.96967 3.71967C4.67678 4.01257 4.67678 4.48743 4.96967 4.78033C5.26257 5.07322 5.73744 5.07322 6.03033 4.78033L7.75 3.06066ZM1 2C0.58579 2 0.25 2.33579 0.25 2.75C0.25 3.16421 0.58579 3.5 1 3.5H1.75V11.75C1.75 12.9927 2.75736 14 4 14H13C14.2427 14 15.25 12.9927 15.25 11.75V3.5H16C16.4142 3.5 16.75 3.16421 16.75 2.75C16.75 2.33579 16.4142 2 16 2H14.5C14.0858 2 13.75 2.33579 13.75 2.75V11.75C13.75 12.1642 13.4142 12.5 13 12.5H4C3.58579 12.5 3.25 12.1642 3.25 11.75V2.75C3.25 2.33579 2.91421 2 2.5 2H1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveSmall);
export default __webpack_public_path__ + "static/media/unarchive_small.f0092794a848f97725a6ed9db62d11e3.svg";
export { ForwardRef as ReactComponent };